/* unplugin-vue-components disabled */import script from "./WORWORelationsEditCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WORWORelationsEditCard.vue?vue&type=script&setup=true&lang=js"

import "./WORWORelationsEditCard.vue?vue&type=style&index=0&id=120ddf2c&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120ddf2c"]])

export default __exports__